<template>
  <el-form
    class="default-locations-form"
    size="small"
    label-position="top"
  >
    <el-row
      :gutter="20"
      type="flex"
    >
      <el-col :span="8">
        <el-form-item>
          <span slot="label">{{
            $t('defaultLocations.search.description')
          }}</span>
          <el-autocomplete
            v-model="formData.description"
            value-key="label"
            clearable
            :fetch-suggestions="
              (text, cb) => {
                searchAnalyses({ text, cb, field: 'description' });
              }
            "
            :trigger-on-focus="false"
            @select="searchLocation"
            @change="emptySelectedAnalysis"
          >
            <template slot-scope="{ item }">
              <AutocompleteAnalysis :item="item" />
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item>
          <span slot="label">{{ $t('defaultLocations.search.code') }}</span>
          <el-autocomplete
            v-model="formData.code"
            value-key="label"
            clearable
            :fetch-suggestions="
              (text, cb) => {
                searchAnalyses({ text, cb, field: 'code' });
              }
            "
            :trigger-on-focus="false"
            @select="searchLocation"
            @change="emptySelectedAnalysis"
          >
            <template slot-scope="{ item }">
              <AutocompleteAnalysis
                :item="item"
                :showIcon="false"
              />
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import AutocompleteAnalysis from '@/components/AutocompleteAnalysis.vue';

  import { analysesApi } from '@/api';

  const initialFormData = {
    description: '',
    code: '',
    analysisId: null,
    instrument: '',
    method: '',
  };

  export default {
    name: 'DefaultLocationsSearch',
    components: {
      AutocompleteAnalysis,
    },
    data() {
      return {
        formData: { ...initialFormData },
      };
    },
    computed: {
      ...mapGetters(['forms']),
    },
    methods: {
      ...mapActions(['updateForm']),
      async searchAnalyses({ text, cb, field }) {
        if (text.length >= 3) {
          const response = await analysesApi.autocompleteFetch(
            field,
            text,
            true,
            false
          );
          const analyses = response.data.map((a) => ({
            value: a.id,
            code: a.code,
            description: a.description,
            method: a.method,
            accreditedTest: a.accreditedTest,
            instrument: a.brand,
          }));
          cb(analyses);
        } else {
          cb([]);
        }
      },
      searchLocation(item) {
        this.formData.code = item.code;
        this.formData.analysisId = item.value;
        this.formData.description = item.description;
        this.formData.instrument = item.instrument;
        this.formData.method = item.method;
        this.updateForm({
          formKey: 'defaultLocations',
          formData: this.formData,
        });
        this.$emit('handle-locations-list-update');
      },
      emptySelectedAnalysis(text) {
        if (text === '') {
          this.formData.analysisId = null;
          this.formData.code = null;
          this.formData.description = null;
          this.formData.instrument = null;
          this.formData.method = null;
          this.updateForm({
            formKey: 'defaultLocations',
            formData: this.formData,
          });
          this.$emit('handle-locations-list-update');
        }
      },
    },
    watch: {
      'forms.defaultLocations': {
        handler(data) {
          this.formData = { ...data };
        },
        deep: true,
      },
    },
    created() {
      this.formData = Object.keys(this.forms.defaultLocations).length
        ? { ...this.forms.defaultLocations }
        : { ...initialFormData };
    },
  };
</script>

<style lang="scss" scoped>
  .default-locations-form {
    padding-bottom: 20px;
    min-height: $filter-form-min-height;

    .el-form-item {
      &__label {
        color: $--color-text-regular;
        min-height: $filter-label-min-height;
      }

      &--small {
        .el-form-item {
          &__label {
            padding-bottom: 15px;
            line-height: 1;
            min-height: $filter-label-min-height;
          }
        }
      }

      .el-autocomplete {
        width: 100%;
      }
    }
  }
</style>
